import React from 'react';
import styles from './CtaBar.module.scss';

export default function CtaBar( props ) {
	return (
		<div className={`${props.className} ${styles['cta-bar']}`}>{props.children}</div>
	);
}
